module.exports = __webpack_public_path__ + "img/room.7c7021b0.svg";